$(window).scroll(function () {
    if ($(this).scrollTop() > 50) {
        $('header').addClass('__sticky');
    } else {
        $('header').removeClass('__sticky');
    }
});

// Add the white background navigation if the banner is white
$(document).ready(function () {
    if ($('.banner').hasClass('__default-background') || $('.banner').hasClass('__product-two-column') || $('.banner').hasClass('__product')) {
        $('body').addClass('__nav-white-background');
    }

    else {
        $('body').removeClass('__nav-white-background');
    }
});

$(function () {
    if ($('.banner').children('.breadcrumb-wrap')) {
        $('.banner').addClass('__extra-padding');
    }
});